var map = {
	"./404.svg": 3563,
	"./bug.svg": 9971,
	"./chart.svg": 4096,
	"./clipboard.svg": 1457,
	"./component.svg": 8162,
	"./dashboard.svg": 940,
	"./documentation.svg": 1957,
	"./drag.svg": 2811,
	"./edit.svg": 2291,
	"./email.svg": 6359,
	"./example.svg": 135,
	"./excel.svg": 283,
	"./eye.svg": 1542,
	"./form.svg": 3658,
	"./guide 2.svg": 6897,
	"./guide.svg": 5177,
	"./icon.svg": 3980,
	"./international.svg": 5184,
	"./language.svg": 8131,
	"./link.svg": 8647,
	"./list.svg": 862,
	"./lock.svg": 9231,
	"./message.svg": 4188,
	"./money.svg": 9430,
	"./nested.svg": 4221,
	"./password.svg": 5456,
	"./people.svg": 5593,
	"./peoples.svg": 2723,
	"./qq.svg": 7565,
	"./shopping.svg": 3842,
	"./size.svg": 9840,
	"./star.svg": 8944,
	"./tab.svg": 2719,
	"./table.svg": 5525,
	"./theme.svg": 1842,
	"./tree.svg": 1345,
	"./user.svg": 7930,
	"./wechat.svg": 5617,
	"./zip.svg": 9940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3930;